import AvatarPage from "../../../../avatar-page";

const Image = (props) => {
   const { card } = props;
   const getImage = () => {
      if (card?.image?.image_url) {
         return (
            <div className="card-image">
               <img src={card?.image?.image_url} alt="card image" />
            </div>
         )
      } else {
         return (
            <div className="card-image--error">
               <div className="svg-next-icon ic-default-image">
               </div><span>Chưa có hình ảnh</span>
            </div>
         )
      }
   }
   return (
      <div className="row-wrapper">
         <div className="hide-avatar">
            <AvatarPage />
         </div>
         <div className="row-wrapper__children">
            {getImage()}
         </div>
      </div>
   )
}

export default Image;